import { render, staticRenderFns } from "./JointsConfiguratorSelectorPopup.vue?vue&type=template&id=5ce78ccb&scoped=true"
import script from "./JointsConfiguratorSelectorPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./JointsConfiguratorSelectorPopup.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./JointsConfiguratorSelectorPopup.vue?vue&type=style&index=0&id=5ce78ccb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce78ccb",
  null
  
)

export default component.exports